<script>
import MultiSelect from "vue-multiselect";
import Swal from "sweetalert2";

// Custom Components
import { iot_device_type } from "@/helpers/global.variable";
import { authComputed } from "@/state/helpers";
import roomService from "@/helpers/APIService/room.service";
import iotService from "@/helpers/APIService/iot.service";
import errorHandler from "@/helpers/errorHandler";
import middlewares from "@/helpers/middlewares";

export default {
  data() {
    return {
      table: {
        data: [],
        dataCopy: [],
        isLoading: false,
      },
      gatewayOption: [],
      deviceTypeOptions: iot_device_type,
      filter: {
        device_type: { text: "All", value: "all", disabled: false },
        selected_gateway: null,
        device_name: "",
      },
      isApplingFilter: false,
      isGatewayChange: false,
      assignLockToRoom: null,
    };
  },
  props: {
    currentProps: Object,
  },
  computed: {
    ...authComputed,
  },
  components: {
    MultiSelect,
  },
  mounted() {
    this.getGateways();
    this.setValue();
  },
  methods: {
    // Method is used to set values
    setValue() {
      this.assignLockTitle = `Assign lock to Room No ${this.currentProps.assignLockToRoom.room_number}`;
      this.assignLockToRoom = this.currentProps.assignLockToRoom;
    },
    // Method is used to get gateway list
    async getGateways() {
      try {
        this.gatewayOption = [];
        const response = await iotService.getLockGatewayList();
        if (response.length !== 0) {
          let filter = "";
          if (this.assignLockToRoom.lock_iot_device == undefined) {
            filter += "?is_not_assign=true";
          }
          this.getDevices(response[0].id, filter);
          this.filter.selected_gateway = {
            text: response[0].name,
            value: response[0].id,
          };
          response.map((item) => {
            this.gatewayOption.push({ text: item.name, value: item.id });
          });
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to get device list
    async getDevices(gatewayId, filter) {
      try {
        this.table.isLoading = true;
        const response = await iotService.getLockDeviceList(gatewayId, filter);
        if (response) {
          this.table.data = response.sort();
          this.table.dataCopy = response;
          this.table.isLoading = false;
        }
      } catch (error) {
        this.table.isLoading = false;
        errorHandler(error);
      }
    },
    // Method is used to handle Assign and remove IOT device from particuler room
    onRowSelection(data) {
      const isLockAssign =
        this.assignLockToRoom.lock_iot_device == undefined ? true : false;
      Swal.fire({
        title: "Are you sure?",
        text: `You want to ${isLockAssign ? "assign" : "remove"} device to ${
          this.assignLockToRoom.room_number
        }`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.$bvModal.hide("assign-lock-modal");
          let dataToSave = {};
          if (isLockAssign) {
            dataToSave = { lock_iot_device: data.id };
          } else {
            dataToSave = { lock_iot_device: "" };
          }
          roomService
            .editRoom(dataToSave, this.assignLockToRoom.id)
            .then((response) => {
              middlewares.notification(
                `Lock ${
                  isLockAssign ? "assigned to" : "removed from"
                } room successfully !!`,
                "success"
              );
              this.$root.$emit("lock_assign", true);
            })
            .catch((error) => {
              if (error.response.status == 400) {
                if (error.response.data.lock_iot_device) {
                  middlewares.notification(
                    "Lock is already assigned to other room !!",
                    "info",
                    2000
                  );
                }
              }
              errorHandler(error);
            });
        }
      });
    },
    // Method is used to handle gateway change event
    changeGateway() {
      this.getDevices(this.filter.selected_gateway.value);
      this.filter.device_type = {
        text: "All",
        value: "all",
        disabled: false,
      };
    },
    // Method is used to handle gateway change
    applyFilter() {
      this.isApplingFilter = true;
      setTimeout(() => {
        this.isApplingFilter = false;
      }, 1000);
      this.table.data = this.table.dataCopy;
      if (this.filter.device_type.value == "all") {
        this.getDevices(this.filter.selected_gateway.value);
      } else {
        return (this.table.data = this.table.data.filter(
          (item) =>
            item.iot_device_model.device_type ==
              this.filter.device_type.value ||
            (this.filter.device_name !== "" &&
              item.device_name == this.filter.device_name)
        ));
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex align-items-center">
          <label for="gateway">Gateway</label>
          <span class="mx-2">:</span>
          <MultiSelect
            :options="gatewayOption"
            v-model="filter.selected_gateway"
            :show-labels="false"
            :allow-empty="false"
            placeholder="by gateway"
            track-by="value"
            label="text"
            @close="changeGateway()"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="d-flex align-items-center">
          <label for="device_type mb-0">Type</label>
          <span class="mx-2">:</span>
          <MultiSelect
            :options="deviceTypeOptions"
            v-model="filter.device_type"
            :show-labels="false"
            :allow-empty="false"
            placeholder="by gateway"
            track-by="value"
            label="text"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="d-flex align-items-center">
          <label for="device_name mb-0"> Name</label>
          <span class="mx-2">:</span>
          <input
            id="device_name"
            class="form-control"
            type="text"
            placeholder="Device name"
            v-model="filter.device_name"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="col-md-2">
        <b-button
          variant="primary"
          @click="applyFilter"
          :class="{ disabled: isApplingFilter }"
        >
          <i
            v-if="isApplingFilter"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          Apply Filter
        </b-button>
      </div>
    </div>
    <hr />
    <div class="fixTableHead table-responsive">
      <v-table
        class="table-hover table table-hover mb-0"
        :data="table.data"
        selectionMode="multiple"
        selectedClass="table-info"
      >
        <thead slot="head" class="table-light">
          <tr>
            <v-th sortKey="device_name">Device Name</v-th>
            <v-th sortKey="iot_device_model.name">Device Model</v-th>
            <th>Device Type</th>
            <th>Remark</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody
          slot="body"
          slot-scope="{ displayData }"
          v-if="!table.isLoading && table.data.length !== 0"
        >
          <v-tr v-for="row in displayData" :key="row.id" :row="row">
            <td>{{ row.device_name }}</td>
            <td>
              {{
                row.iot_device_model !== null ? row.iot_device_model.name : "-"
              }}
            </td>
            <td>
              {{
                row.iot_device_model !== null
                  ? row.iot_device_model.device_type.replaceAll("_", " ")
                  : "-"
              }}
            </td>
            <td>{{ row.remark !== null ? row.remark : "-" }}</td>
            <td>
              <b-button
                :variant="
                  Boolean(assignLockToRoom.lock_iot_device) &&
                  assignLockToRoom.lock_iot_device.id == row.id
                    ? 'danger'
                    : 'success'
                "
                size="sm"
                :disabled="
                  Boolean(assignLockToRoom.lock_iot_device) &&
                  assignLockToRoom.lock_iot_device.id !== row.id
                "
                @click="onRowSelection(row)"
                >{{
                  Boolean(assignLockToRoom.lock_iot_device) &&
                  assignLockToRoom.lock_iot_device.id == row.id
                    ? "Remove"
                    : "Assign"
                }}</b-button
              >
            </td>
          </v-tr>
        </tbody>
        <tbody slot="body" v-else-if="table.isLoading">
          <tr v-for="item in 3" :key="item">
            <td class="placeholder-glow" v-for="no in 5" :key="no">
              <span class="placeholder w-100 placeholder-lg"></span>
            </td>
          </tr>
        </tbody>
        <tbody slot="body" v-else>
          <tr>
            <td colspan="9" class="text-center">
              <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
              <p>
                <span class="text-secondary">No Data Found</span>
              </p>
            </td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </div>
</template>
